import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Top promo banner advertising the active free-month coupon. Encourages
// registration so we capture the lead (email + phone). Dismissible per session.
export default function PromoBanner() {
  const { user } = useAuth();
  const [promo, setPromo] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("rawaj_promo_dismissed") === "1") { setHidden(true); return; }
    api.get("/coupons/promo").then((r) => setPromo(r.data)).catch(() => {});
  }, []);

  if (!promo || hidden) return null;

  const dismiss = () => { sessionStorage.setItem("rawaj_promo_dismissed", "1"); setHidden(true); };
  const label = promo.discount_percent === 100 ? "هدية التوليد الفردي: صورتان + فيديو + 25 ريال رصيد" : `خصم ${promo.discount_percent}%`;

  return (
    <div
      className="relative z-50 bg-gradient-to-l from-primary via-primary to-accent text-white text-sm"
      data-testid="promo-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3 flex-wrap text-center">
        <Gift className="w-4 h-4 shrink-0" />
        <span className="font-semibold">
          🎁 عرض الإطلاق: استخدم الكود
          <span className="mx-1.5 font-extrabold bg-white/20 rounded-md px-2 py-0.5 tracking-wider" dir="ltr" data-testid="promo-code">{promo.code}</span>
          واحصل على {label}{user ? "" : " — سجّل الآن وابدأ مجاناً!"}
        </span>
        <Link to={user ? "/app/packages" : `/register?next=${encodeURIComponent("/app/packages")}`} data-testid="promo-cta">
          <span className="underline font-bold hover:opacity-90 whitespace-nowrap">{user ? "فعّل التجربة الآن ←" : "سجّل الآن ←"}</span>
        </Link>
      </div>
      <button
        onClick={dismiss}
        aria-label="إغلاق"
        data-testid="promo-dismiss"
        className="absolute top-1/2 -translate-y-1/2 end-3 text-white/80 hover:text-white"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
